export default __webpack_public_path__ + "static/media/image-curiosity.40d51f38.jpg";